import React from 'react';

const RaiseQuery = () => {
  return (
    <div>
      <h1>Raise a Query</h1>
      <p>Hello World - Raise a Query page</p>
    </div>
  );
};

export default RaiseQuery;
